module.exports = __webpack_public_path__ + "img/users.8434c60a.svg";